var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-footer"},[_c('span',{staticClass:"footer-text",staticStyle:{"margin-right":"5px"}},[_c('strong',[_vm._v("Copyright © "+_vm._s(_vm.year)+" "+_vm._s((_vm.year === _vm.currentYear) ? null : '-' + _vm.currentYear)+" Hera trading.")]),_vm._v(" All rights reserved.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }